type Props = {
    mobileimage?: string;
    nonmobileimage?: string;
    alttext?: string;
    imagealignment: string;
};

const SideBySide = ({
    children,
    mobileimage,
    nonmobileimage,
    imagealignment,
    alttext = '',
}: React.PropsWithChildren<Props>) => {
    return (
        <div
            className={`w-full flex flex-col rounded-lg border border-gray md:border-none shadow-md md:${imagealignment} lg:min-h-[350px]`}
        >
            <div className="min-h-48 md:h-auto md:w-1/2">
                {}
                <picture className="">
                    {nonmobileimage && (
                        <source srcSet={nonmobileimage} media="(min-width: 768px)" />
                    )}
                    {mobileimage && <source srcSet={mobileimage} />}
                    <img src={mobileimage} className="h-full w-full rounded-t-lg" alt={alttext} />
                </picture>
            </div>
            <div className="p-6 md:w-1/2 flex flex-col md:justify-center">{children}</div>
        </div>
    );
};

export default SideBySide;
